import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import NoData from "../assets/img/nodata_gray.svg";
import { BASE_URL, TypeValueChain } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";
import { formatDate } from "../helpers/commons";
import { TypeProcessingData } from "../pages/processing/CreateProcessingPage";

export const useProcessingData = () => {
  const navigate = useNavigate();
  const [loadingData, setLoadingData] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const [processingData, setProcessingData] = useState<TypeProcessingData[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();

  const getProcessingData = async () => {
    setLoadingData(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/processing",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingData(false);
        setProcessingData(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as { message: string; status: string };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingData(false);
      });
  };

  return { loadingData, processingData, getProcessingData };
};
